module.exports = {"TXTCLI_Apply__forChanges":{"id":"TXTCLI_Apply__forChanges","defaultMessage":"Alkalmaz","flags":["TRACK"],"track":"Apply"}}